<template>
  <div>
    <q-dialog v-model="valueLocal" persistent>
      <q-card class="card-authorization">
        <q-card-section class="header">
          <div class="text-h6" id="title-card-authorization">
            Añadir informe de diagnóstico
          </div>
        </q-card-section>
        <q-card-section class="container-auth q-pt-none q-col-gutter-y-sm">
          <slot name="body">
            <!--Nombre-->
            <div class="row">
              <q-input
                outlined
                label="Nombre"
                class="col-12 required"
                v-model.trim="$v.nombre.$model"
                :error="$v.nombre.$error"
              >
                <template v-slot:error>
                  <span>Dato obligatorio.</span>
                </template>
              </q-input>
            </div>
            <div class="row">
              <q-file
              class="col-12 file required"
              outlined
              v-model="file"
              label="Seleccione archivo"
              max-file-size="10485760"
              accept=".pdf"
              :error="$v.file.$error"
              @rejected="onRejected">
                <template v-slot:append>
                  <q-icon name="attachment"></q-icon>
                </template>
              </q-file>
            </div>
            <!--observaciones-->
            <div class="row">
              <q-input
                v-model="observaciones"
                type="textarea"
                label="Observaciones"
                outlined
                class="col-12"
              ></q-input>
            </div>
          </slot>
        </q-card-section>

        <q-card-actions align="right" class="text-primary container-actions">
          <q-btn
            class="bSecondary"
            flat
            label="Cancelar"
            v-close-popup
            @click="cancel()"
          />
          <q-btn
            label="AÑADIR INFORME"
            class="bPrincipal"
            padding="xs lg"
            @click="save()"
            :disabled="!isValidFrom()"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { QDialog } from 'quasar';
import { required } from 'vuelidate/lib/validators';
import Message from '@/components/shared/mixins/Message.js';
import moment from 'moment';
export default {
  components: {
    QDialog
  },
  mixins: [Message],
  props: {
    value: {
      required: true
    }
  },
  validations: {
    nombre: { required },
    file: { required }
  },
  data () {
    return {
      valueLocal: this.value,
      nombre: '',
      observaciones: '',
      newInforme: {},
      file: null
    };
  },
  created () {
    this.clean();
  },
  watch: {
    value: {
      handler: function () {
        this.clean();
        this.valueLocal = this.value;
        this.$emit('input', this.valueLocal);
      },
      immediate: true
    }
  },
  methods: {
    cancel () {
      this.clean();
      this.$emit('input', false);
      this.$v.$reset();
    },
    clean () {
      this.nombre = '';
      this.observaciones = '';
      this.file = null;
    },
    save () {
      this.$v.$touch();
      if (!this.$v.$error) {
        this.newInforme = {
          nombre: this.nombre,
          observaciones: this.observaciones,
          informeAdjuntoNombre: this.file ? this.file.name : '',
          fechaSubida: this.file ? moment(new Date(Date.now())).format('DD/MM/YYYY') : '',
          fileInformeAdjunto: this.file ? this.file : ''
        };
        this.$v.$reset();
        this.$emit('input', false);
        this.$eventHub.$emit('saveNewInforme', this.newInforme);
      }
    },
    isValidFrom () {
      return ((this.nombre !== '' && this.nombre !== null) && (this.file !== undefined && this.file !== null));
    },
    onRejected () {
      this.showError(`No es un fichero valido, debe ser .pdf y tamaño maximo 10MB`);
    }
  }
};
</script>

<style lang="scss" scoped>
.card-authorization {
  min-width: 700px;
  .header {
    padding-top: 18px;
    #title-card-authorization {
      font-family: DINPro;
      font-size: 24px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: $azulcabecera;
    }
  }
  .container-actions {
    padding-top: 15px;
  }
  .container-auth {
    padding-top: 20px;
    padding-bottom: 25px;
    .title-option {
      font-family: DINPro;
      font-size: 15px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #5c5c5c;
      padding-bottom: 20px;
    }
  }
  &::v-deep {
    .q-field--standard .q-field__control:before {
      border-bottom-color: rgba(89, 89, 89, 0.5) !important;
    }
  }
}
.q-dialog__inner {
  div::v-deep {
    border-radius: 12px !important;
  }
  .file {
    padding-right: 5px;
    padding-bottom: 20px;
  }
}
.q-card {
  padding-left: 40px;
  padding-right: 40px;
}
</style>
